import * as frappeSDK from "frappe-react-sdk";
const _f = (frappeSDK as any).default || frappeSDK;
const { useFrappeGetCall } = _f as Pick<typeof frappeSDK, "useFrappeGetCall">;

export interface PractitionerAward {
  name?: string;
  award: string;
}

export interface DoctorEducation {
  year: string;
  detail: string;
}

export interface DoctorAvailability {
  day: string;
  slots: string[];
}

export interface Doctor {
  name: string;
  practitioner_name: string;
  role?: string;
  department: string;
  qualifications?: string | string[];
  specialties?: string | string[];
  experience: string;
  languages?: string | string[];
  rating: number;
  reviews: number;
  image?: string | null;
  bio: string;
  gender: string;
  nmc_number?: string;
}

export interface DoctorDetail extends Doctor {
  availability: DoctorAvailability[];
  education: DoctorEducation[];
  awards: PractitionerAward[] | string[];
  // Frappe custom fields matching exact doctype payload
  custom_fellowship__training?: string;
  custom_memberships?: string;
  custom_research_and_publications?: string;
  meta_title?: string;
  meta_description?: string;
}

export const useDoctors = () => {
  const { data, isLoading, error } = useFrappeGetCall<{ message: Doctor[] }>(
    "health_web.api.doctors.get_doctors",
    undefined,
    "doctors",
  );

  return {
    doctors: data?.message ?? [],
    isLoading,
    error,
  };
};

export const useDoctor = (name: string | undefined) => {
  const { data, isLoading, error } = useFrappeGetCall<{ message: DoctorDetail }>(
    "health_web.api.doctors.get_doctor",
    name ? { name } : undefined,
    name ? `doctor_${name}` : undefined,
  );

  return {
    doctor: data?.message ?? null,
    isLoading,
    error,
  };
};